<!-- 企业入驻信息 -->
<style lang="scss" scoped>
.company-item-wrapper {
  background: #ffffff;

  .company-item-upload-box {
    display: flex;
    justify-content: space-between;

    .label {
      display: flex;
      justify-content: space-between;
    }
  }

  .required {
    &::before {
      content: '*';
      color: #ff0000;
      margin-right: 4px;
    }
  }

  .example {
    height: 28px;
    color: $color-primary;
    cursor: pointer;
    border-bottom: 1px solid $color-primary;
  }
}

.no-show-star {
  :deep() {
    .el-form-item__label {
      width: 100% !important;
      text-align: end;
      height: 22px;
      &::before {
        content: '' !important;
      }
    }
  }
}
</style>

<template>
  <div class="company-item-wrapper">
    <el-form ref="formRef" :model="form" :rules="rules" size="large" label-position="top" label-width="90px">
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="required mb-4px">
            上传证照(系统将自动识别填写证件信息，请核对识别结果，如有错误请手动修改。图片格式支持jpg/jpeg/png，单张图片大小不超过2M)
          </div>
          <div class="company-item-upload-box">
            <el-form-item prop="businessLicenseUrl">
              <div>
                <img-upload
                  v-model="form.businessLicenseUrl"
                  :dir="OSS_DIR.BUSINESS_LICENSE"
                  height="160"
                  width="278"
                  :size-limit="2"
                  accept="image/jpg,image/jpeg,image/png"
                  @change="postOcrBusinessLicense"
                >
                  <template #empty>
                    <div class="text-14px color-#666666"><span class="upload-txt">点击</span><span class="drag-txt">/拖拽至此处上传文件</span></div>
                    <div class="color-#999999">（支持jpg/jpeg/png格式，不超过 2 M）</div>
                  </template>
                </img-upload>
                <div class="label">
                  <span class="required">营业执照</span>
                  <span class="example" @click="preview(OssFile.BUSINESS_LICENSE_EXAMPLE)">示例</span>
                </div>
              </div>
            </el-form-item>
            <el-form-item prop="legalIdentityCardFrontUrl">
              <div class="">
                <img-upload
                  v-model="form.legalIdentityCardFrontUrl"
                  :dir="OSS_DIR.ID_CARD"
                  height="160"
                  width="278"
                  :size-limit="2"
                  accept="image/jpg,image/jpeg,image/png"
                  @change="postOcrIdentityCardFront"
                >
                  <template #empty>
                    <div class="text-14px color-#666666"><span class="upload-txt">点击</span><span class="drag-txt">/拖拽至此处上传文件</span></div>
                    <div class="color-#999999">（支持jpg/jpeg/png格式，不超过 2 M）</div>
                  </template>
                </img-upload>
                <div class="label">
                  <span class="required">法定代表人身份证人像面</span>
                  <span class="example" @click="preview(OssFile.IDENTITY_CARD_FRONT_EXAMPLE)">示例</span>
                </div>
              </div>
            </el-form-item>
            <el-form-item prop="legalIdentityCardBackUrl">
              <div class="">
                <img-upload
                  v-model="form.legalIdentityCardBackUrl"
                  :dir="OSS_DIR.ID_CARD"
                  height="160"
                  width="278"
                  :size-limit="2"
                  accept="image/jpg,image/jpeg,image/png"
                  @change="postOcrIdentityCardBack"
                >
                  <template #empty>
                    <div class="text-14px color-#666666"><span class="upload-txt">点击</span><span class="drag-txt">/拖拽至此处上传文件</span></div>
                    <div class="color-#999999">（支持jpg/jpeg/png格式，不超过 2 M）</div>
                  </template>
                </img-upload>
                <div class="label">
                  <span class="required">法定代表人身份证国徽面</span>
                  <span class="example" @click="preview(OssFile.IDENTITY_CARD_BACK_EXAMPLE)">示例</span>
                </div>
              </div>
            </el-form-item>
          </div>
        </el-col>

        <el-col :span="24">
          <el-form-item label="企业名称" prop="corpName">
            <el-input v-model="form.corpName" placeholder="请输入企业名称" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="统一社会信用代码" prop="companyCreditCode">
            <el-input v-model="form.companyCreditCode" maxlength="18" placeholder="请输入统一社会信用代码" />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="营业执照有效期" prop="businessLicenseFromDate">
            <el-date-picker v-model="form.businessLicenseFromDate" style="width: 100%" type="date" value-format="YYYY-MM-DD" placeholder="开始日期" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <div class="no-show-star">
            <el-form-item prop="businessLicenseEndDate">
              <template #label>
                <el-checkbox
                  v-model="form.businessLicenseLongTerm"
                  class="long-term-checkbox"
                  label="结束日期：长期"
                  :true-label="1"
                  :false-label="0"
                  name="type"
                  @change="
                    (e) => {
                      longChange(e, 'businessLicenseEndDate')
                    }
                  "
                />
              </template>
              <el-date-picker
                v-model="form.businessLicenseEndDate"
                style="width: 100%"
                :disabled="!!form.businessLicenseLongTerm"
                type="date"
                value-format="YYYY-MM-DD"
                placeholder="结束日期"
              />
            </el-form-item>
          </div>
        </el-col>

        <el-col :span="16">
          <el-form-item label="注册地址" prop="companyAddress">
            <el-input v-model="form.companyAddress" placeholder="请输入注册地址" />
            <!-- <el-cascader
              ref="cascaderCity"
              v-model="form.registerAddressCode"
              style="width: 100%"
              :options="regionOptions"
              placeholder="请选择经营省市区"
              separator=""
              filterable
              @change="handleRegionChange"
            /> -->
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item label="注册资本" prop="registerCapital">
            <el-input
              v-model="form.registerCapital"
              placeholder="请输入注册资本"
              class="text-right"
              :is-number="true"
              :number-format="{
                decimal: true, // 是否支持小数
                negative: false, // 是否支持负数
                leadingZero: false, // 是否支持前导零，如 001
                maxDecimalLength: 6,
              }"
            >
              <template #append> 万 </template>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="经营范围" prop="businessScope">
            <el-input v-model="form.businessScope" placeholder="请输入经营范围" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
  <ImgViewer v-model:visible="showImgViewer" :url-list="currentUrlList" :show-mini-image="false" :prev-btn="false" :next-btn="false" />
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { OSS_DIR } from '@/constants/common'
import OssFile from '@/constants/oss-file'
import userApi from '@/apis/user'
import { validateUnifiedSocialCreditCode } from '@/common/js/validator' // 验证规则
import { dealTime } from '@/utils/utils' // 时间格式
import { identifyEmpty } from './data'

const showImgViewer = ref(false)
const currentUrlList = ref([])
const preview = (url) => {
  showImgViewer.value = true
  currentUrlList.value = [url]
}

const form = ref({
  corpName: '', // 企业名称
  companyCreditCode: '', // 统一社会信用代码
  businessScope: '', // 经营范围
  // registerAddressCode: '', // 注册地址代码code集合
  registerCapital: '', // 注册资本 单位：万元
  businessLicenseFromDate: '', // 营业执照开始日期
  businessLicenseEndDate: '', // 营业执照结束日期
  businessLicenseLongTerm: 0, // 营业执照是否长期
  businessLicense: null, // 营业执照
  legalIdentityCardFrontUrl: null, // 法定代表人身份证人像面
  legalIdentityCardBackUrl: null, // 法定代表人身份证国徽面
  businessLicenseUrl: null, // 营业执照
  companyAddress: '', // 注册地址
  // provinceCode: '', // 省份代码
  // cityCode: '', // 城市代码
  // districtCode: '', // 区县代码
  // provinceName: '', // 省份名称
  // cityName: '', // 城市名称
  // districtName: '', // 区县名称
})

const emit = defineEmits(['setFormData'])

watch(
  () => form.value,
  (newVal) => {
    //更新joinForm
    emit('setFormData', newVal)
  },
  { deep: true },
)

const props = defineProps({
  joinForm: {
    type: Object,
    default: () => {},
  },
})

watch(
  () => props.joinForm,
  (newVal) => {
    if (newVal) {
      //只设置form中存在的字段
      for (const key in newVal) {
        if (newVal[key] !== undefined && newVal[key] !== null && key in form.value) {
          form.value[key] = newVal[key]
        }
      }
    }
  },
  { deep: true, immediate: true },
)

// 自定义统一社会信用代码验证规则
const checkCompanyCreditCode = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('请输入统一社会信用代码'))
  }
  if (!validateUnifiedSocialCreditCode(value)) {
    return callback(new Error('统一社会信用代码式为18位'))
  }
  callback()
}

// 自定义营业执照结束日期检验规则
const checkBusinessLicenseEndDate = (rule, value, callback) => {
  if (form.value.businessLicenseFromDate && value && dealTime(form.value.businessLicenseFromDate) > dealTime(value)) {
    callback(new Error('结束日期不能小于开始日期'))
  } else if (value || form.value.businessLicenseLongTerm) {
    callback()
  } else {
    callback(new Error('请选择结束日期'))
  }
}

const rules = ref({
  corpName: [{ required: true, message: '请输入企业名称', trigger: 'blur' }],
  companyCreditCode: [
    {
      required: true,
      validator: checkCompanyCreditCode,
      trigger: ['blur', 'change'],
    },
  ],
  businessLicenseFromDate: [{ required: true, message: '请选择开始日期', trigger: 'change' }],
  businessLicenseEndDate: [
    {
      required: true,
      validator: checkBusinessLicenseEndDate,
      trigger: 'change',
    },
  ],
  companyAddress: [{ required: true, message: '请选择经营省市区', trigger: 'blur' }],
  registerCapital: [{ required: true, message: '请输入注册资本', trigger: ['blur', 'change'] }],
  businessScope: [{ required: true, message: '请输入经营范围', trigger: ['blur', 'change'] }],
  businessLicenseUrl: [{ required: true, message: '请上传营业执照', trigger: 'none' }],
  legalIdentityCardFrontUrl: [{ required: true, message: '请上传法定代表人身份证人像面', trigger: 'none' }],
  legalIdentityCardBackUrl: [{ required: true, message: '请上传法定代表人身份证国徽面', trigger: 'none' }],
})

//长期赋值
const longChange = (e, key) => {
  e ? (form.value[key] = '2099-12-31') : (form.value[key] = '')
}

// const cascaderCity = ref(null)

// // 处理省市区选择
// const handleRegionChange = (value) => {
//   form.value.provinceCode = value[0]
//   form.value.cityCode = value[1]
//   form.value.districtCode = value[2] || ''
//   // 获取省市区的name
//   nextTick().then(() => {
//     const labelArr = cascaderCity.value.getCheckedNodes()[0].pathLabels // 获取由 label 组成的数组
//     form.value.provinceName = labelArr[0]
//     form.value.cityName = labelArr[1]
//     form.value.districtName = labelArr[2] || ''
//   })
// }

//营业执照ocr识别
const postOcrBusinessLicense = async (url) => {
  form.value.businessLicenseUrl = url
  if (!url) return

  const res = await userApi.postBusinessLicenseOcr({
    licenseUrl: url,
  })
  //OCR识别数据处理 (无 || '--')
  identifyEmpty(res)
  if (!res.companyName && !res.companyCreditCode && !res.businessLicenseLegalName) {
    form.value.businessLicenseUrl = ''
    return ElMessage.error('检测到您上传的不是营业执照,或者图片不清晰，识别不出来，请重新上传')
  }
  form.value.corpName = res.companyName //企业名称
  form.value.companyCreditCode = res.companyCreditCode //统一社会信用代码
  form.value.businessLicenseFromDate = res.businessLicenseFromDate //营业执照开始日期
  form.value.businessLicenseEndDate = res.businessLicenseEndDate //营业执照结束日期
  form.value.businessLicenseLongTerm = res.businessLicenseLongTerm //营业执照是否长期
  form.value.registerCapital = res.companyRegisterCapital //注册资本
  form.value.companyAddress = res.companyAddress //注册地址
  form.value.businessScope = res.companyBusinessScope //经营范围
}

//身份证正面ocr识别
const postOcrIdentityCardFront = async (url) => {
  form.value.legalIdentityCardFrontUrl = url
  if (!url) return
  const res = await userApi.postIdCardFrontOcr({
    identityCardFrontUrl: url,
  })

  //OCR识别数据处理 (无 || '--')
  identifyEmpty(res)

  emit('setFormData', {
    legalName: res.name,
    legalIdentityCard: res.identityCard,
    legalHouseholdAddress: res.householdAddress,
  })
}

//身份证反面ocr识别
const postOcrIdentityCardBack = async (url) => {
  form.value.legalIdentityCardBackUrl = url
  if (!url) return
  const res = await userApi.postIdCardBackOcr({
    identityCardBackUrl: url,
  })
  //OCR识别数据处理 (无 || '--')
  identifyEmpty(res)
  emit('setFormData', {
    legalIdentityCardIssuingAuthority: res.identityCardIssuingAuthority, // 签发机关
    legalIdentityCardFromDate: res.identityCardFromDate, // 开始日期
    legalIdentityCardEndDate: res.identityCardEndDate, // 结束日期
    legalIdentityCardLongTerm: res.identityCardLongTerm, // 是否长期
  })
}

//更新法人信息form数据
const updateForm = (data) => {
  Object.assign(form.value, data)
}

const formRef = ref(null) // 表单ref
defineExpose({
  form: computed(() => form.value),
  updateForm,
  validate: () => {
    return formRef.value?.validate()
  },
})
</script>
